// @flow

// Libs
import React from 'react'

// Styles
import { primary } from 'fc-styles/src/colors'

// Components
import SortIcon from 'fc-icons/src/Sort'

// Types
type Props = {
  color?: string,
  size?: number,
}

export default function DescIcon ({color = primary(), size = 16}: Props): React.Element<any> {
  return (
    <SortIcon
      color={color}
      size={size}
    />
  )
}
